import { toast } from 'react-toastify';
import { calculateArea, calculateCenterOfPolygon, calculatePerimeter } from '../../../../../../core/utils/map.utils';
import { sendDataToParent } from '../../../../base/functions/sendDataToParent';

export const polygonOnDragEndAction = (e) => {
    /*checking _latlngs[0].length ensures only polygons get through and not polylines which will cause an error*/
    if (e.target._latlngs[0].length >= 3) {
        // console.log('drag check: ', e.target);
        const draggedPolygonCoords = e.target._latlngs[0].map((coord) => {
            return { lat: coord.lat, lng: coord.lng };
        });
        const draggedPolygonArea = calculateArea(draggedPolygonCoords);
        const draggedPolygonCenter = calculateCenterOfPolygon(draggedPolygonCoords);
        const draggedPolygonPerimeter = calculatePerimeter(draggedPolygonCoords);

        sendDataToParent({
            type: 'polygon-dragged',
            draggedPolygonId: e.target._leaflet_id,
            draggedPolygonCoords,
            draggedPolygonArea,
            draggedPolygonCenter,
            draggedPolygonPerimeter,
        });

        toast.success('با موفقیت انجام شد', { toastId: 'success' });
    }
};
